import { gql } from '@/__generated__';
import { DataExtraction_GetReportTemplatesQuery } from '@/__generated__/graphql';

export type ReportTemplate = DataExtraction_GetReportTemplatesQuery['reportTemplates'][number];

const GET_REPORT_TEMPLATES = gql(`#graphql
query DataExtraction_GetReportTemplates {
  reportTemplates {
    id
    name
    description
    timezone
    meanWindow
    emails
    relativeDate: relativeTime
    createExcel
    createPdf
    metrics {
      metricName: name
      unit
    }
    devices {
      id
      profile {
        id
        name
      }
    }
    schedules {
      id
      timezone
      recurrence
      dayOfWeek
      hours
      minutes
      daysOfWeek
    }
    createdAt
  }
}
`);

export default GET_REPORT_TEMPLATES;
